
import Vue from 'vue'
import Transformer from '@/transformers/transformer'
import errorHandler  from '@/utils/errorHandler'

class SearchTransformer extends Transformer {
  static fetch({ id, folio_jb, requisition_number, sinister_number,
                 roads_id }) {
    return {
      id, folioJB: folio_jb,
      sinisterNumber: sinister_number, requisitionNumber: requisition_number,
      roadsId: roads_id,
    }
  }
}

function paramsTransformer({ text, process }) {
  return {
    search_data: text,
    process: process ? process : undefined,
  }
}

export default (text, options={}) =>  {


  const { isExtranet } = options || {}
  const url = !isExtranet
    ? 'sinisters/search_sinister/'
    : 'sinisters/extranet/search_sinister/'
  return errorHandler(
    Vue.$http.get(url, { 
      params: paramsTransformer({ text, ...options })
    })).then(response => SearchTransformer.fetchCollection(response.data))
}



// WEBPACK FOOTER //
// ./src/services/sinister/quickSearch.js